export default __webpack_public_path__ + "static/media/666.b750f974.png";